import { render, staticRenderFns } from "./addshopTostore.vue?vue&type=template&id=3860635e&scoped=true&"
import script from "./addshopTostore.vue?vue&type=script&lang=js&"
export * from "./addshopTostore.vue?vue&type=script&lang=js&"
import style0 from "./addshopTostore.vue?vue&type=style&index=0&id=3860635e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860635e",
  null
  
)

export default component.exports